import Container from 'react-bootstrap/Container';
import {Component} from 'react'
import {Nav, Navbar, NavDropdown} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import logon from './getlogo.png'
import twitterBlue from './twitterBlue.png'
import slackIm from './slackIm.png'


function Navigation() {
  return (
    <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" fixed ="top">
      <Container>
        <Navbar.Brand href="/" style={{backgroundImage: "linear-gradient(60deg, #00eeff, #ff00d9)", webkitBackgroundClip: "text",
       webkitTextFillColor: "transparent", fontWeight:"bold", fontFamily: "poppins", marginTop: "px"}}>
        <img src={logon} width="40px" style={{marginBottom: "4px"}}/>
        AiWrite
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="social-post-writer">Social Post</Nav.Link>
            <Nav.Link href="product-description-writer">Product Description</Nav.Link>
            <Nav.Link href="seo-content-writer">SEO Content</Nav.Link>
            <Nav.Link href="cold-email">Cold email</Nav.Link>
          </Nav>
          <Nav>
          <Nav.Link href="https://join.slack.com/t/aichatgroupe/shared_invite/zt-1sph5ja6o-Uzp~C~up7x3WbLhsF4~rYQ" target="_blank" ><div className="slackwaladiv"><img src={slackIm} style={{width:"20px"}}/><span style={{fontSize:"14px", paddingLeft:"4px"}}>Support</span></div></Nav.Link>
          <Nav.Link href="https://twitter.com/Arzamaan1" target="_blank"><img src={twitterBlue} style={{width:"25px"}}/></Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;
